import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from '@mui/material';
import { getListsForObject } from './listGenerators';
export const ObjectAdjacentLinks = (props) => (_jsx(Stack, { gap: 2, children: getListsForObject(props) }, "ObjectAdjacentLinks"));
